var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('labels',{attrs:{"value":_vm.labels,"hide-exclude":""},on:{"changed":_vm.submit},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('v-btn',_vm._g({attrs:{"color":"primary","small":"","disabled":_vm.disabled,"outlined":""}},on),[_vm._v(" "+_vm._s(_vm.btnText))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }